
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1iee7_1sc3h_9",
  "announcer": "awsui_announcer_1iee7_1sc3h_17"
};
  